/** User-facing DNA upload guidance — genealogy-focused, not medical. */

export const DNA_UPLOAD_TITLE = 'Upload raw DNA data';

export const DNA_UPLOAD_INTRO =
  'Upload a raw DNA data file from a genealogy DNA provider. This is usually a .zip or .txt file downloaded from your provider account.';

export const DNA_UPLOAD_SUPPORTED_PROVIDERS = [
  'AncestryDNA',
  'MyHeritage',
  'FamilyTreeDNA',
  'Living DNA',
  'GEDmatch',
  'Other compatible raw DNA file',
];

export const DNA_UPLOAD_LEGACY_23ANDME_NOTE =
  'Already have a 23andMe raw DNA file? You may still upload it for compatibility testing, but we no longer list 23andMe as a recommended provider.';

export const DNA_UPLOAD_FILE_WARNING =
  'Please do not upload medical reports, ethnicity screenshots, or PDF summaries. We only support raw autosomal DNA data files for genealogy matching tests.';

export const DNA_UPLOAD_PRIVACY_NOTE =
  'DNA data is sensitive. Your file stays private in your archive unless you choose to use future matching or connection features.';

export const DNA_UPLOAD_RESULT_TITLE = 'DNA file preserved privately';

export const DNA_UPLOAD_RESULT_STATUS =
  'We found a compatible raw DNA data file. It has been stored privately in this archive.';

export const DNA_UPLOAD_RESULT_WHAT_NEXT =
  'Your DNA file is preserved privately. Matching is currently in early access. When matching becomes available, you’ll be able to review possible family connections and choose what, if anything, to share.';

export const DNA_UPLOAD_RESULT_LOW_MARKER_NOTE =
  'Small test file detected. This file can be used to test upload handling, but it may not contain enough markers for future DNA matching.';

export const DNA_UPLOAD_RESULT_PRIVACY =
  'DNA data is sensitive. Your file will not be shared or compared with other archives unless you choose to enable future matching features.';

export const DNA_UPLOAD_RESULT_FUTURE_MATCHING =
  'In future, MyLegacyBridge may use raw DNA files to help identify possible family connections, support relationship validation, and strengthen archive discovery.';

export const DNA_UPLOAD_RESULT_DISCLAIMER =
  'MyLegacyBridge does not provide health reports, medical advice, ethnicity estimates, legal identity verification, or paternity testing.';

export const DNA_UPLOAD_INVALID_GENEALOGY_MESSAGE =
  'This does not look like a raw genealogy DNA data file. Please upload a .zip, .txt or .csv file downloaded from your DNA provider.';

export const DNA_UPLOAD_ACCEPT_ATTR = '.zip,.txt,.csv';
